<template>
  <AppBtn v-bind="overrideProps" v-on="listeners">
    <template v-for="(index, name) in $slots" v-slot:[name]>
      <slot :name="name" />
    </template>
    <template v-for="(index, name) in $scopedSlots" v-slot:[name]="data">
      <slot :name="name" v-bind="data"></slot>
    </template>
    <template v-slot:default>
      <slot />
    </template>
  </AppBtn>
</template>

<script>
import { VBtn } from 'vuetify/lib';
import AppBtn from './AppBtn.vue';
export default {
  components: { AppBtn },
  props: VBtn.props,
  data () {
    return {
      doubleClickPrevent: false
    }
  },
  computed: {
    baseBindValues () {
      const propsCopied = { ...this.$props }
      return {
        ...propsCopied,
        ...this.$attrs
      }
    },
    listeners () {
      const { click, ...rest } = this.$listeners ?? {}

      return {
        ...rest,
        click: this.wrapClick(click)
      }
    },
    overrideProps () {
      const { disabled, ...rest } = this.baseBindValues

      return {
        block: true,
        rounded: true,
        xLarge: true,
        class: 'py-3 text-medium--w-bold',
        ...rest,
        disabled: this.doubleClickPrevent || disabled
      }
    }
  },
  methods: {
    wrapClick (click) {
      return (...args) => {
        if (this.noDc) {
          this.doubleClickPrevent = true
          setTimeout(() => {
            this.doubleClickPrevent = false
          }, 1000)
        }
        return click(...args)
      }
    }
  }
}
</script>
